var publicLinks = [{
  label: "In\xEDcio",
  ariaLabel: "inicio",
  href: "/"
}, {
  label: "Quem Somos",
  ariaLabel: "quem somos",
  href: "/quem-somos"
}, {
  label: "Cart\xF5es de Cr\xE9dito",
  ariaLabel: "cart\xF5es de cr\xE9dito",
  href: "/cartao-de-credito"
}, {
  label: "Blog",
  ariaLabel: "blog",
  href: "https://www.consumidorpositivo.com.br/blog/"
}];
var privateLinks = [{
  label: "Home",
  path: "/home/"
}, {
  label: "Meus objetivos",
  path: "/meus-objetivos/"
}, {
  label: "Ofertas para mim",
  path: "/ofertas/"
}, {
  label: "Meus pedidos",
  path: "/meus-pedidos/"
}, {
  label: "Minha conta",
  path: "/minha-conta/"
}, {
  label: "Alterar senha",
  path: "/alterar-senha/"
}, {
  label: "Notifica\xE7\xF5es",
  path: "/notificacoes/"
}, {
  label: "Central de ajuda",
  path: "/ajuda/"
}, {
  label: "Sair da conta",
  path: "/sair/"
}];
var navigationMap = {
  publicLinks: publicLinks,
  privateLinks: privateLinks
};
export { navigationMap };